import { BreakpointKey } from "@insite/mobius/utilities/breakpointMediaQueries";
import getBreakpointIndex from "@toolkit/Framework/Common/Utilities/getBreakpointIndex";
import { StyledTheme } from "@toolkit/Framework/Types/StyledTheme";

export default (breakpoint: BreakpointKey, theme: StyledTheme) => {
    const keys = theme.breakpoints.keys;
    return keys[getBreakpointIndex(breakpoint, theme) - 1] || keys[0];
};
